const CategoryAhanPageORGEN = [
    {
        ID: 3001,
        Name: "Profile",
        ImageURL: "image/cat-1-1.jpg",
        CategoryID: 2001,
        CompanyName: "Tehran",
        Details: "2mm 20 * 10",
    },
    {
        ID: 3002,
        Name: "Angle",
        ImageURL: "image/cat-1-2.jpg",
        CategoryID: 2002,
        CompanyName: "Arian Foolad",
        Details: "",
    },
    {
        ID: 3003,
        Name: "I-Beam",
        ImageURL: "image/cat-1-3.jpg",
        CategoryID: 2003,
        CompanyName: "Zob Ahan",
        Details: "",
    },
    {
        ID: 3004,
        Name: "Rebar",
        ImageURL: "image/cat-1-4.jpg",
        CategoryID: 2004,
        CompanyName: "Isfahan",
        Details: "",
    },
    {
        ID: 3005,
        Name: "Stainless Steel Sheet",
        ImageURL: "image/cat-1-5.jpg",
        CategoryID: 2005,
        CompanyName: "Isfahan",
        Details: "",
    },
    {
        ID: 3006,
        Name: "Sheet",
        ImageURL: "image/new-cat-1-1.jpg",
        CategoryID: 2006,
        CompanyName: "Isfahan",
        Details: "",
    },
    {
        ID: 3007,
        Name: "Pipe",
        ImageURL: "image/cat-1-8.jpg",
        CategoryID: 2007,
        CompanyName: "Isfahan",
        Details: "",
    },
    {
        ID: 3008,
        Name: "Wire Products",
        ImageURL: "image/cat-1-9.jpg",
        CategoryID: 2008,
        CompanyName: "Isfahan",
        Details: "",
    },
]

export default CategoryAhanPageORGEN;